<template>
  <div>
    <v-card til flat>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4">Views</v-col>
          <v-col cols="5">
            <v-text-field
              v-model="ui.views.search"
              label="Search"
              single-line
              clearable
              hide-details
            >
              <template v-slot:append>
                <v-icon color="primary">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn
              class="primary"
              tile
              width="245"
              height="60"
              text
              :to="{ name: 'dashboard.views.create' }"
              >New View</v-btn
            >
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="views"
        :search.sync="ui.views.search"
        :page.sync="ui.views.page"
        :items-per-page.sync="ui.views.perPage"
        :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
      >
        <template v-slot:item.banners="{ item }">
          {{
            item.banners.filter(
              (banner) =>
                banner.isActive &&
                banner.permission &&
                (banner.panelStatus || banner.forceShow)
            ).length
          }}
          / {{ item.banners.length }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row no-gutters justify="end">
            <Tokens class="ml-1" :view="item" />

            <ViewShow :view="item" />
            <v-btn
              tile
              text
              class="ml-2 my-4 px-6 warning"
              height="60"
              :to="{ name: 'dashboard.views.edit', params: { id: item._id } }"
              >Edit</v-btn
            >
            <ViewEdit :view="item" />
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";

import { mapGetters, mapActions, mapState } from "vuex";

export default Vue.extend({
  name: "Views",
  props: ["links"],
  components: {
    Tokens: () => import("@/components/Dashboard/Tokens"),
    ViewEdit: () => import("@/components/Dashboard/ViewEdit"),
    ViewShow: () => import("@/components/Dashboard/ViewShow"),
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Name",
          value: "name",
        },
        { text: "View creator", value: "creator" },
        { text: "Description", value: "description" },
        // { text: "Role", value: "role" },
        { text: "Banners active/total", value: "banners" },
        { text: "ID", value: "_id" },
        { text: "", value: "action", sortable: false, align: "right" },
      ],
    };
  },
  computed: {
    ...mapGetters(["views", "view", "viewBanners", "role", "user"]),
    ...mapState(["ui"]),
  },
  methods: {
    ...mapActions(["fetchViews", "createToken"]),
  },
  mounted() {
    this.fetchViews({});
    if (this.user.superUser) {
      this.headers.splice(2, 0, { text: "Role", value: "role" }, 3);
    }
  },
});
</script>

<style lang="scss" scope>
.views-home {
  margin: 20px 0 0;
}
.nav-link.btn {
  padding: 0.2em 0.5em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ef3f37;
  cursor: pointer;
  color: #ef3f37;
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  margin: 0 10px 10px 0;
  transition-property: border-color, color;
  transition-duration: 200ms;
  &:hover {
    background-color: rgba(239, 64, 55, 0.06);
    // color: #c1263e;
    // border-color: #c1263e;
  }
}
</style>
